export default "__VITE_ASSET__CF1GtVFG__";